import emoji from "emoji-dictionary"
import CodeFormatter from "../components/CodeFormatter"
import { fs } from "../controls/Constants"

const KariBegin = () => {
    const introduction = 
    `The kariBegin function is a fundamental part of the Kari Arduino Library, designed to make the initialization of multiple pins in your Arduino projects
    more efficient and straightforward.As a developer, setting up pins is often one of the first and most crucial steps in ensuring your hardware 
    communicates effectively with your software.kariBegin addresses this need by providing a flexible method to configure multiple pins at once,
    reducing complexity and potential for errors in your setup process.\n
    With kariBegin, you can effortlessly initialize pins as either input or output, depending on the requirements of your project. 
    This flexibility allows you to tailor your pin configurations to meet the specific needs of various sensors, actuators, and other components connected to your Arduino. 
    By automating the setup process, kariBegin enhances the overall efficiency of your development workflow, enabling you to focus on building and refining the core functionality of your application.\n
    Designed with ease of use and reliability in mind, kariBegin ensures that your pins are correctly initialized with minimal code, making it an indispensable tool for both beginners and experienced developers. 
    Whether you're working on a simple hobby project or a complex industrial application, kariBegin provides the foundation for a robust and responsive system, allowing you to bring your innovative ideas to life with confidence and precision.
    `

    const codeSnippet =
    `#include <kari.h>

void setup() {
    kariBegin({8, 7, 6, 5}); // pins being initialized as outputs
    kariBegin({4, 3, 2}, true); // pins being initialized as inputs
}

void loop() {
    kariAsync::execute(
    [] () {
        kariSequential({{8, 7, 6, 5}, "sequence 1"});
    },
    1500
    );
}
    `
    return (
    <>
      <section>
        <h1>{emoji.getUnicode("gear")} kariBegin</h1>
        <h2>Introduction</h2>
        <p className={`text-formatter ${fs}`}>{introduction}</p>
    </section>
    <section>
        <h2>{emoji.getUnicode("wrench")} Key Features</h2>
        <ul className={`${fs}`}>
            <li><strong>Batch Pin Setup </strong>- Allows initializing multiple pins at once.</li>
            <li><strong>Input & Output Modes</strong> - Can configure pins as inputs or outputs.</li>
            <li><strong>Optimized for Efficiency</strong> - Reduces repetitive <span className="yellow">pinMode()</span> calls.</li>
        </ul>
    </section>
    <h2>{emoji.getUnicode("hammer_and_wrench")} API Reference</h2>
    <CodeFormatter codeSnippet={
        `void kariBegin(std::vector<int> pins, bool setAsInputs=false); `
    } />
    <h3>Description:</h3>
    <ul className={`${fs}`}>
        <li><strong>{`std::vector<int>`}</strong> - A list of pin numbers to initialize.</li>
        <li><strong>setAsInputs</strong> - If true, sets pins as INPUTS; otherwise, they are OUTPUTS.It's false by default.</li>
    </ul>
    <ul className={`${fs}`}>
    </ul> 
    <h2>{emoji.getUnicode("hammer")} Basic Usage Example</h2>
    <CodeFormatter
    codeSnippet={codeSnippet}
    />     
    </>
    )
}

export default KariBegin
